import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import type { ItilTranslationStatus } from '../types';
import { isItilGateBlocked } from '../utils';
import { itilColors } from '../styles';

type Props = {
  statuses: ItilTranslationStatus[];
  mode?: 'creation' | 'closing';
};

function ItilFormFooter({ statuses, mode = 'creation' }: Props) {
  const { t } = useTranslation('global');
  const blocked = statuses.some((s) => isItilGateBlocked(s));
  const pending = statuses.filter((s) => isItilGateBlocked(s)).length;
  const allReady = statuses.every((s) => s === 'ready');
  const hasSkipped = statuses.some(
    (s) => s === 'skipped' || s === 'storedAsOriginal'
  );

  let message = '';
  let color = itilColors.req;

  if (allReady) {
    message =
      mode === 'closing'
        ? t('itilGenius.gate.closingReady')
        : t('itilGenius.gate.allReady');
    color = itilColors.ok;
  } else if (hasSkipped && !blocked) {
    message = t('itilGenius.gate.continueOriginal');
    color = itilColors.warn;
  } else if (blocked) {
    message =
      mode === 'closing'
        ? t('itilGenius.gate.closingBlocked')
        : t('itilGenius.gate.pending', { count: pending });
    color = itilColors.req;
  }

  if (!message) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
      <Typography
        sx={{ fontSize: '12px', color: itilColors.inkSoft, fontWeight: 600 }}
        variant="body2"
      >
        <Box component="span" sx={{ color, fontWeight: 700, mr: 0.5 }}>
          {allReady ? '✓' : hasSkipped && !blocked ? '!' : '!'}
        </Box>
        {message}
      </Typography>
    </Box>
  );
}

export default ItilFormFooter;
